import { formatHtml } from "@trumpf/ux.common-storybook";
import { MultipleTemplate, Template } from "./contact-card.template";

export default {
    title: "Components/Contact Card",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-contact-card",
    argTypes: {
        image: {
            control: {
                type: "text",
            },
        },
        _title: {
            control: {
                type: "text",
            },
        },
        _subTitle: {
            control: {
                type: "text",
            },
        },
        _text: {
            control: {
                type: "text",
            },
        },
        _details: {
            control: {
                type: "text",
            },
        },
    },
};

export const ContactCard = {
    args: {
        image: "",
        _title: "Thomas Mischer",
        _subTitle: "Chief Executive Mischer",
        _text: "<p>this text may contain some unstructured information</p>",
        _details: `<a slot="details" href="tel:123456789">Tel: 123456789</a>
        <a slot="details" href="#">Email: thomas.mischer@trumpf.com</a>
        <a slot="details" class="ux-text-link ux-text-link--green" href="#">This is a green Link</a>`,
    },
};

export const ContactCardWithImage = {
    args: {
        image: "mock-assets/images/contact-square.avif",
        _title: "TRUMPF Title",
        _subTitle: "Chief Laser Officer",
        _text: "",
        _details: `<a slot="details" href="tel:123456789">Tel: 123456789</a>
        <a slot="details" href="#">Email: thomas.mischer@trumpf.com</a>`,
    },
};

export const MultipleContactCards = {
    render: MultipleTemplate,
};
